import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import {
    GridColDef,
    GridPaginationModel,
    GridRowParams,
} from '@mui/x-data-grid';

import { DataGrid, DataGridCard } from '@barboxx/admin-components';
import { useAuth, usePaging } from '@barboxx/admin-utils';
import Api from '@barboxx/api';

const COLUMNS: GridColDef[] = [
    { field: 'id', headerName: 'Id', width: 100 },
    { field: 'firstName', headerName: 'First Name', width: 170, flex: 1 },
    { field: 'lastName', headerName: 'Last Name', width: 170, flex: 1 },
    {
        field: 'email',
        headerName: 'Email',
        width: 170,
        flex: 1,
    },
    {
        field: 'roles',
        headerName: 'Roles',
        headerAlign: 'right',
        width: 200,
        align: 'right',
        sortable: false,
    },
    {
        field: 'userType',
        headerName: 'Type',
        headerAlign: 'right',
        width: 200,
        align: 'right',
        sortable: true,
    },
    {
        field: 'active',
        headerName: 'Active',
        headerAlign: 'right',
        type: 'boolean',
        width: 100,
        align: 'right',
        sortable: true,
    },
];

interface Props {
    searchString?: string;
}

export default function UsersList({ searchString }: Props) {
    const navigate = useNavigate();
    const {
        auth: { user },
    } = useAuth();
    const { page, size, sort, updatePageModel, updateSort } = usePaging();

    const { data, isLoading, error } = useQuery({
        queryKey: ['users', page, size, sort, searchString],
        queryFn: () => Api.Users.getUsers({ page, size, sort, searchString }),
    });

    const handleChangePageModel = (pageModel: GridPaginationModel) => {
        updatePageModel(pageModel);
    };

    const handleRowClick = (param: GridRowParams) => {
        navigate(`${param.id}`);
    };

    return (
        <DataGridCard>
            <DataGrid
                columns={COLUMNS.filter(
                    c =>
                        !(
                            c.field === 'userType' &&
                            user.userType === 'Business'
                        )
                )}
                disableColumnMenu
                disableRowSelectionOnClick
                error={error}
                loading={isLoading}
                onRowClick={handleRowClick}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onSortModelChange={updateSort}
                rows={data?.data?.results ?? []}
                onPaginationModelChange={handleChangePageModel}
                rowCount={data?.data?.total ?? 0}
            />
        </DataGridCard>
    );
}
